import {Component, Inject, OnInit} from '@angular/core';
import {User} from '../../../data/models/user';
import {UserService} from '../../../services/api/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-user-unblock-dialog',
  templateUrl: './user-unblock-dialog.component.html',
  styleUrls: ['./user-unblock-dialog.component.css']
})
export class UserUnblockDialogComponent implements OnInit {

  user: User;

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<UserUnblockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = data.user;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.userService.unblockUser(this.user.id)
      .then(user => {
        this.dialogRef.close(user);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
